export const MIN_NON_DISABLED_ELEMENTS_IN_CONTENT_LIBRARY = 1;
export const ONE_MINUTE = 1;
export const ONE_DAY = 1;
export const INFINITE_TIME = 1e15;
export const MS_IN_SEC = 1000;
export const SEC_IN_MIN = 60;
export const MS_IN_MIN = SEC_IN_MIN * MS_IN_SEC;
export const MIN_IN_HOUR = 60;
const MS_IN_HOUR = MS_IN_MIN * MIN_IN_HOUR;
export const HOURS_IN_DAY = 24;
export const JOB_DISPLAY_LINK_PLACEHOLDER = '{job_display_link}';
export const THROTTLE_TIMEOUT = 750;
export const CLIPBOARD_TTL = 2 * MS_IN_HOUR;
export const MIN_NUMBER_OF_REQUIRED_PLACEMENTS = 1;
export const MIN_NUMBER_OF_REQUIRED_META_PLACEMENTS = 1;
export const MIN_INSTAGRAM_PLACEMENTS_IF_REELS_SELECTED = 2;

// source: https://stackoverflow.com/a/3809435
export const URL_REGEX =
    /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.(?<topLevelDomain>[a-zA-Z0-9()]{1,6}\b)([-a-zA-Z0-9()[\]@:%_+.,~#?&!//=]*)$/;
export const WHATS_APP_URL_REGEX = /https:\/\/wa.(me|link)\//;
export const CALENDAR_START_DAY_MONDAY = 1;
export const YOUTUBE_COM_URL_REGEX = /(https:\/\/youtu.be\/)|(https:\/\/www.youtube.com\/)|(https:\/\/youtube.com\/)/;
export const MAX_YOUTUBE_URL_LENGTH = 255;
export const DEFAULT_DAILY_BUDGET = 20;
export const DATE_TIME_PICKER_TIME_INTERVAL = 15;
export const MAX_LANDING_PAGE_URL_LENGTH = 700;
export const HEVC_CODEC_MIME_REGEX = /(codecs=)(.*?)(\b(hvc|hev)\d)/;
export const ARROW_KEY_CODES = [37, 38, 39, 40];
export const MR_WORK_SUPPORT_EMAIL = 'support@mrwork.nl';
export const MR_WORK_PRODUCT_EMAIL = 'product@mrwork.nl';
export const MR_WORK_SALES_EMAIL = 'sales@mrwork.nl';
export const LEADS_URL_REGEX =
    /(?<!["']>|["'])(?:(?:https?:\/\/)|www\.|(?:https?:\/\/)www\.|)(?:\w+\.)+\w+(?:\/[a-z0-9A-Z-._~:/?#[\]@!$&'()*+,;=%]*)?/g;
export const WEBHOOK_URL_REGEX =
    /(https:\/\/flows.messagebird.com\/flows\/(.*)\/invoke)|(https:\/\/capture.eu-west-1.nest.messagebird.com\/webhooks)/;
export const EMAIL_REGEX =
    /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
export const LEADS_UNSUPPORTED_MESSAGE = 'Unsupported message type';
export const CONSISTENT_MEDIA_TYPE_INFO = 'Feed Media must use same media type across all advertisements';
export const UNASSIGNED_OPTION_VALUE = 'unassigned';
export const DEFAULT_URL_SOURCE_PARAMETER = 'mrwork';
export const SYSTEM_OPTION_VALUE = 'system';
export const NUMBER_WITH_TWO_DIGIST_REGEX = /^-?[0-9]+(\.[0-9]{1,2})?$/;
export const INSERTION_MARK = '<?>';
export const contactUs = {
    bookDemoUrlJobs:
        'https://www.mrwork.nl/demo-form?utm_source=webapp&utm_medium=promotion&utm_campaign=demo&utm_content=jobs',
    bookDemoUrlBrands:
        'https://www.mrwork.nl/demo-form?utm_source=webapp&utm_medium=promotion&utm_campaign=demo&utm_content=brands',
    bookDemoUrlLeads:
        'https://www.mrwork.nl/demo-form?utm_source=webapp&utm_medium=promotion&utm_campaign=demo&utm_content=leads',
    contactViaWhatsapp: 'https://wa.me/31107371521',
};
export const CUSTOMER_SUPPORT_CENTER_URL = 'https://support.mrwork.nl/hc/nl-nl';
export const SEARCH_PARAMETER_NAME_FOR_DUPLICATED_CAMPAIGN = 'from';
export const STOP_EVENT = 'ai-stop-generating';
export const CHANNEL_GRACE_PERIOD = 10;
export const LAST_ALLOWED_DATE_2024_BRANDS = '2024-12-31T22:00:00Z';
export const FIRST_ALLOWED_DATE_2025_BRANDS = '2025-01-01T02:00:00Z';
export const BA_ID_FROM_URL_REGEX = /\/b\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;
export const DOMAIN_REGEX = /^[a-z0-9]+([a-z0-9-]*[a-z0-9])*(\.[a-z0-9]+([a-z0-9-]*[a-z0-9])*)*\.[a-z]{2,}$/;
export const BROWSER_FRAME_DURATION = 100 / 6;

export const MENU_COLLAPSED_WIDTH = 64;
export const MENU_WIDTH_EMBEDDED_MODE = 0;
export const MENU_EXPANDED_WIDTH = 220;

export const MOBILE_BREAKPOINT_PX = 1143;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX}px)` as const;
export const MOBILE_CSS_MEDIA_QUERY = `@media (max-width: ${MOBILE_BREAKPOINT_PX}px)` as const;

export const MOBILE_VIEWPORT_BREAKPOINT_PX = 768;
export const MOBILE_VIEWPORT_MEDIA_QUERY = `(max-width: ${MOBILE_VIEWPORT_BREAKPOINT_PX}px)` as const;
export const MOBILE_VIEWPORT_CSS_MEDIA_QUERY = `@media (max-width: ${MOBILE_VIEWPORT_BREAKPOINT_PX}px)` as const;
